<!-- XIcon — heroicons-outline X SVG per UI-SPEC §5 -->
<template>
    <svg
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="h-5 w-5"
    >
        <path d="M6 18L18 6M6 6l12 12" />
    </svg>
</template>
